import { TEST_IDS } from '@/lib/testIds'
import { Button } from '@/ui/shadcn/button'

interface ErrorScreenProps {
  error: Error
  onTryAgain: () => void
}

export function ErrorScreen({ error, onTryAgain }: ErrorScreenProps) {
  return (
    <main
      className="grid min-h-svh place-items-center bg-background p-6 text-foreground"
      data-testid={TEST_IDS.errorScreen}
    >
      <section className="w-full max-w-xl space-y-5 rounded-2xl border bg-card p-6 shadow-lg sm:p-8">
        <div className="space-y-2">
          <p className="text-sm font-medium text-destructive">Insta Little Helper</p>
          <h1 className="text-2xl font-semibold tracking-tight">Something broke</h1>
          <p className="rounded-lg bg-muted p-3 font-mono text-sm break-words">{error.message}</p>
        </div>
        <p className="text-xs text-muted-foreground">
          Version {__APP_VERSION__} · Commit {__APP_COMMIT__}
        </p>
        <div className="flex justify-end">
          <Button
            type="button"
            variant="outline"
            data-testid={TEST_IDS.errorTryAgain}
            onClick={onTryAgain}
          >
            Try again
          </Button>
        </div>
      </section>
    </main>
  )
}
